/**
 * Becker Orthopedic
 *
 * Fancybox lightbox — loaded only by pages that use .fancybox
 */

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

Fancybox.bind(".fancybox");
